import { render, staticRenderFns } from "./RelayStep.vue?vue&type=template&id=4ab8c45d"
import script from "./RelayStep.vue?vue&type=script&lang=ts"
export * from "./RelayStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports